import Header from "@/types/app/header";

export default class JobInfoHeader {
  public static header: Header[] = [
    {
      text: "Description",
      align: "start",
      sortable: true,
      value: "description",
      class: "item-table-header item-table-header-description",
      width: ""
    },    
    {
      text: "Next Execution",
      align: "start",
      sortable: true,
      value: "nextExecution",
      class: "item-table-header item-table-header-nextExecution",
      width: ""
    },
    {
      text: "Last Execution",
      align: "start",
      sortable: true,
      value: "lastExecution",
      class: "item-table-header item-table-header-lastExecution",
      width: ""
    }
  ];
}
